// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import siteMessage from "@insite/client-framework/SiteMessage";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { Button } from "@insite/mobius/index";
import { mergeWithCss } from "@stanion/XDL/Utilities";
import React, { FC, useState } from "react";

interface OwnProps {
    startDate: string;
    endDate: string;
    title: string;
    location: string;
    extendedStyles?: CalenderExportStyles;
    linkText?: string;
    isOneDayEvent?: boolean;
}

interface CalenderExportStyles {
    button?: ButtonPresentationProps;
}

const calenderExportStyles: CalenderExportStyles = {};

const CalenderExport: FC<OwnProps> = ({
    startDate,
    endDate,
    extendedStyles,
    title,
    location,
    linkText,
    isOneDayEvent = false,
}) => {
    const [styles] = useState(() => mergeWithCss(calenderExportStyles, extendedStyles));

    const handleExport = () => {
        const icsContent = [
            "BEGIN:VCALENDAR",
            "BEGIN:VEVENT",
            `DTEND:${endDate}`,
            `DTSTART:${startDate}`,
            `${!isOneDayEvent && `RRULE:FREQ=DAILY;UNTIL=${endDate}`}`,
            "SEQUENCE:0",
            `SUMMARY:${title}`,
            `LOCATION: ${location}`,
            "TRANSP:OPAQUE",
            "END:VEVENT",
        ].join("\n");

        const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = "event.ics";
        downloadLink.click();
        URL.revokeObjectURL(url);
    };
    return (
        <Button onClick={handleExport} {...styles.button}>
            {linkText || siteMessage("Custom_EventPage_CalenderFile")}
        </Button>
    );
};

export default CalenderExport;
